<h1>Stories</h1>

<ng-container *ngIf="stories$ | async as stories; else loadingOrError">
  <ng-container *ngIf="stories.length > 0; else noStories">
    <em>{{stories.length}} {{stories.length === 1 ? 'story' : 'stories'}}</em>
    <div class="story" *ngFor="let story of stories">
      <div class="story-info">
        <h2 class="title" [routerLink]="[nav_path.stories, story.id]">
          <anon-story-title [type]="story.type" [status]="story?.problemStatus">{{story.title}}</anon-story-title>
        </h2>
        <p>{{story.byline}}</p>
        <div class="bottom">
          <span>{{story.author?.name}}</span>
          <div class="icons">
            <mat-icon aria-label="Comments are disabled" [style.visibility]="story.allowComments ? 'hidden' : 'visible'">comments_disabled</mat-icon>
            <mat-icon aria-label="Private story" [style.visibility]="story.visibility === 'private' ? 'visible' : 'hidden'">public_off</mat-icon>
            <mat-icon aria-label="Featured story" [style.visibility]="story.featured ? 'visible' : 'hidden'">verified</mat-icon>
          </div>
        </div>
      </div>
      <div class="story-actions">
        <button mat-icon-button [matMenuTriggerFor]="storyMenu"
                [matMenuTriggerData]="{story: story}">
          <mat-icon>more_horiz</mat-icon></button>
        <mat-menu #storyMenu="matMenu">
          <ng-template matMenuContent let-story="story">
            <button mat-menu-item>
              <mat-slide-toggle [checked]="story.featured"
                                (change)="storyFeaturedChanged($event, story)">
                Featured</mat-slide-toggle>
            </button>
            <button mat-menu-item>
              <mat-slide-toggle [checked]="story.visibility === 'public'"
                                (change)="storyPublicChanged($event, story)">
                Public</mat-slide-toggle>
            </button>
            <button mat-menu-item (click)="deleteStory(story)">Delete Story</button>
          </ng-template>
        </mat-menu>
      </div>
    </div>
  </ng-container>
  <ng-template #noStories>
    <div class="">
      <h2 class="">No stories yet!</h2>
      <p class="">Create the first story to get us started.</p>
      <div class="btn-container">
        <button type="button" mat-button [routerLink]="nav_path.newStory">Create New Story</button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
   <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
